import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { MyPreset } from '../styles';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { authInterceptor } from './core/auth/interceptors/auth.interceptor';
import { MessageService } from 'primeng/api';
import { NgxUiLoaderHttpModule, NgxUiLoaderModule, NgxUiLoaderRouterModule } from 'ngx-ui-loader';
import { environment } from './environments/enviornment.dev';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: MyPreset,
        options: {
          darkModeSelector: '.my-app-dark',
          cssLayer: {
            name: 'primeng',
            order: 'theme, base, primeng',
          },
        },
      },
    }),
    provideHttpClient(withInterceptors([authInterceptor]), withInterceptorsFromDi()),
    importProvidersFrom(
      NgxUiLoaderRouterModule,
      NgxUiLoaderModule.forRoot({
        fgsType: 'square-jelly-box',
        fgsColor: '#ffa700',
        pbColor: '#ffa700',
        bgsColor: '#ffa700',
      }),
      NgxUiLoaderHttpModule.forRoot({
        showForeground: true,
        exclude: [
          `${environment.apiUrl}/api/uploadImages`,
          `${environment.apiUrl}/api/patient/`,
          `${environment.apiUrl}/api/video/like-status`,
          `${environment.apiUrl}/api/video/:videoId/toggle-like`,
          `${environment.apiUrl}/api/video/increment-view`,
          `${environment.apiUrl}/api/file/upload-part`,
          `${environment.apiUrl}/api/file/complete`,
          `${environment.apiUrl}/api/file/initiate`,
          `${environment.apiUrl}/api/video/comments/*`,
          `${environment.apiUrl}/api/video/:video_id/comments`,
          `${environment.apiUrl}/api/series`,
        ],
        excludeRegexp: [
          `${environment.apiUrl}/api/videos/comments/.*`,
          `${environment.apiUrl}/api/follows/.*`,
        ],
      }),
    ),
    MessageService,
  ],
};
